import { useRouteError } from 'react-router-dom';

interface RouteError {
  statusText?: string;
  message?: string;
  error?: {
    message?: string;
  };
}

function PageError() {
  const error = useRouteError() as RouteError;
  console.error(error);

  return (
    <div className="h-screen flex flex-col items-center justify-center">
      {/* <div className='text-2xl'>Oops!</div> */}
      <h1 className='text-5xl mt-4' >页面异常</h1>
      <p className='text-2xl mt-4' >
        <i>{error.statusText || error.message || ''}</i>
      </p>
      {
        (import.meta.env.DEV) &&
        <p className='text-md mt-4' >
          <i>{error?.error?.message || ''}</i>
        </p>
      }
    </div>
  );
}

export default PageError;